<template>
  <div id='bd-notfound' style="text-align: center">
    <el-header>
      <!-- <cm-header></cm-header> -->
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="6" id="left-col">
          <div class="grid-content"></div>
        </el-col>
        <el-col :span="12" id="middle-col">
          <div><h1>404，未找到相关页面</h1></div>
        </el-col>
        <el-col :span="6" id="right-col">
          <div class="grid-content"></div>
        </el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
// import CmHeader from '@/components/common/CmHeader'

export default {
  name: 'bd-notfound',
  // components: { CmHeader },
  data () {
    return {}
  }
}
</script>

<style scoped>
#bd-notfound {
  height: 100%;
}
.grid-content {
  min-height: 36px;
}
</style>
